import Icon from "@ant-design/icons";
import { ReactComponent as InstagramSvg } from "./svg/instagram.svg";

const InstagramIcon = (props) => <Icon component={InstagramSvg} {...props} />;

export default InstagramIcon;
